export const toDate = (dateLike: Date | string) => new Date(dateLike)
